
import {Component, Vue} from 'vue-property-decorator';
import {UserModule} from '@/store/modules/user';
import {currentNavigation, MenuEntry} from '@/layout/platform-navigation';
import SidebarItemLink from '../Sidebar/SidebarItemLink.vue';

@Component({components: {SidebarItemLink}})
export default class Navigation extends Vue {
    get current() {
        return currentNavigation(UserModule.menuList as unknown as MenuEntry[], this.$route.path, this.$route.meta && this.$route.meta.parentRoute);
    }
    get activeTool() { return this.current && this.current.tools.find(this.isActive); }
    get visibleTabs() {
        if (!this.current) return [];
        return this.activeTool ? [...this.current.tabs, this.activeTool] : this.current.tabs;
    }
    isActive(item: MenuEntry) { return item.u === this.$route.path || item.u === (this.$route.meta && this.$route.meta.parentRoute); }
    openTool(path: string) { if (path !== this.$route.path) this.$router.push(path); }
}
